import React, { useState } from 'react';
import { styles as topicStyles } from './Topics/TopicStyles';

const Footer = () => {
  const [modalContent, setModalContent] = useState(null); // 'terms', 'privacy', 'refund', null

  const openModal = (type) => setModalContent(type);
  const closeModal = () => setModalContent(null);

  // 📝 법적 고지 내용 (표준 템플릿)
  const LEGAL_TEXTS = {
    terms: {
      title: "서비스 이용약관",
      content: `
제 1조 (목적)
본 약관은 'The Pivot'(이하 "회사")이 제공하는 논리 전장 서비스의 이용과 관련하여 회사와 회원의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.

제 2조 (게시판 운영)
본 게시판은 화면 상단 로고 아래 'RULES(게시판 안내)'에 따라 운영됩니다.

제 3조 (포인트 및 결제)
1. 회원은 '유료 전장 참여, 진영 변경, 타 게시글 신고'를 위해 포인트를 결제하여 충전할 수 있습니다.
2. 포인트는 회사의 서비스 내에서만 사용 가능하며, 타인에게 양도할 수 없습니다.
3. 충전한 포인트의 사용기한은 1년입니다.

제 4조 (금지행위)
회원은 욕설, 비방, 허위사실 유포 등 타인의 권리를 침해하는 행위를 해서는 안 되며, 위반 시 계정 이용이 제한될 수 있습니다.

제 5조 (서비스의 변경 및 중단)
회사는 천재지변, 시스템 점검 등의 사유로 서비스를 일시 중단할 수 있으며, 이 경우 사전에 공지합니다.

제 6조 (자동화된 콘텐츠 분석)
1. 본 서비스는 건전한 게시판 환경을 조성하기 위해 Google Jigsaw의 'Perspective API'를 활용하여 콘텐츠의 유해성(욕설, 비방 등)을 자동으로 분석합니다.
2. AI 분석 결과는 참고용 자료로 제공되며, AI 알고리즘의 특성상 판독에 오류가 발생할 수 있습니다. 회사는 해당 분석 결과의 완전성이나 정확성을 보장하지 않으며, 이에 따른 결과에 대해 법적 책임을 지지 않습니다.
      `
    },
    privacy: {
      title: "개인정보처리방침",
      content: `
1. 수집하는 개인정보 항목
회사는 회원가입, 원활한 고객상담, 각종 서비스의 제공을 위해 아래와 같은 개인정보를 수집하고 있습니다.
- 수집항목: 닉네임, 휴대폰 번호, 비밀번호, 결제기록 
- 수집방법: 홈페이지 회원가입, 결제 서비스 이용

2. 개인정보의 수집 및 이용목적
- 회원 관리: 본인확인, 개인식별, 불량회원의 부정이용 방지
- 서비스 제공: 포인트 결제, 콘텐츠 이용

3. 개인정보의 보유 및 이용기간
회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.

[전자상거래 등에서의 소비자보호에 관한 법률]
- 계약 또는 청약철회 등에 관한 기록: 5년
- 대금결제 및 재화 등의 공급에 관한 기록: 5년
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년

[통신비밀보호법]
- 접속 로그 기록: 3개월

4. 개인정보 보호책임자
- 책임자: 고세현
- 이메일: rnoc987@naver.com
      `
    },
    refund: {
      title: "환불 규정",
      content: `
1. 환불 원칙
- 모든 환불 처리는 이용자가 결제한 수단과 동일한 수단으로 대금을 환급하는 것을 원칙으로 합니다. 결제 수단 이외의 방법(현금 입금 등)으로는 환불이 불가능합니다.
- 회원은 포인트 결제 후 7일 이내에, 사용하지 않은 포인트에 한하여 전액 환불을 요청할 수 있습니다.

2. 환불 불가 사유
- 이미 사용한 포인트
- 이벤트나 보상으로 무상 지급받은 포인트
- 결제 후 7일이 경과한 경우

3. 환불 절차
- MYPAGE의 '포인트 충전 및 사용 내역 관리 - 결제/환불 내역'에서 결제한 내역에 대해 환불 가능합니다.(결제 후 7일 이내)
      `
    }
  };
  
  return (
    <>
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.row}>
          {/* 1. 로고 및 간단 소개 */}
          <div style={styles.column}>
            <h2 style={styles.logo}>THE PIVOT</h2>
            <p style={styles.text}>
              논리와 이성이 승리하는 논리 전장.<br/>
              당신의 통찰력을 증명하고 보상을 획득하세요.
            </p>
          </div>

          {/* 2. 법적 필수 표기 사항 (사업자 정보) */}
          <div style={styles.column}>
            <h4 style={styles.heading}>BUSINESS INFO</h4>
            <p style={styles.text}>
              상호명: 더 피봇 (The Pivot)<br/>
              대표자: 고세현<br/>
              사업자등록번호: 673-48-01245<br/>
              통신판매업신고: 제 2026-대전유성-0311 호<br/>
              주소: 대전광역시 유성구 궁동 425-8<br/>
              이메일: rnoc987@naver.com | 고객센터: 010-3855-4271<br/>
              호스팅 서비스 제공자: Vercel & Render
            </p>
          </div>

          {/* 3. 이용약관 및 환불규정 (클릭 시 모달) */}
          <div style={styles.column}>
            <h4 style={styles.heading}>POLICY & TERMS</h4>
            <ul style={styles.list}>
              <li style={styles.listItem} onClick={() => openModal('terms')}>이용약관</li>
              <li style={{...styles.listItem, fontWeight: 'bold', color: '#fff'}} onClick={() => openModal('privacy')}><strong>개인정보처리방침</strong></li>
              <li style={styles.listItem} onClick={() => openModal('refund')}>
                <span style={{textDecoration: 'underline'}}>환불 규정 (Refund)</span>
              </li>
              <li>*The Pivot에서 판매되는 모든 상품은 The Pivot에서 책임지고 있습니다.(민원 담당자: 고세현 | 연락처: 010-3855-4271)</li>
            </ul>
          </div>
        </div>

        <div style={{...styles.copyright, color: '#aaa'}}>
          © {new Date().getFullYear()} THE PIVOT. All rights reserved. | Powered by Perspective API
        </div>
      </div>
    </footer>

    {/* 법적 고지 모달 */}
    {modalContent && (
        <div style={topicStyles.rulesOverlay} onClick={closeModal}>
            <div style={{...topicStyles.rulesContent, maxWidth: '600px'}} onClick={e => e.stopPropagation()}>
                <div style={topicStyles.modalHeader}>
                    <h2 style={{margin: 0, fontSize: '1.2rem'}}>{LEGAL_TEXTS[modalContent].title}</h2>
                    <button style={topicStyles.closeBtn} onClick={closeModal}>✕</button>
                </div>
                <div style={{padding: '20px', color: '#ccc', lineHeight: '1.6', whiteSpace: 'pre-wrap', maxHeight: '60vh', overflowY: 'auto'}}>
                    {LEGAL_TEXTS[modalContent].content}
                </div>
            </div>
        </div>
    )}
    </>
  );
};

const styles = {
  footer: {
    backgroundColor: '#050505',
    borderTop: '1px solid #222',
    color: '#888',
    padding: '40px 20px',
    fontSize: '0.85rem',
    marginTop: 'auto', // 내용을 밀어내고 바닥에 붙게 함
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '30px',
  },
  column: {
    flex: '1 1 250px', // 반응형 너비
    marginBottom: '20px',
  },
  logo: {
    color: '#fff',
    fontSize: '1.2rem',
    fontWeight: '900',
    marginBottom: '10px',
    letterSpacing: '1px',
  },
  heading: {
    color: '#fff',
    fontSize: '0.9rem',
    marginBottom: '10px',
    fontWeight: 'bold',
  },
  text: {
    lineHeight: '1.6',
  },
  list: {
    listStyle: 'none',
    padding: 0,
  },
  listItem: {
    marginBottom: '8px',
    cursor: 'pointer',
  },
  copyright: {
    borderTop: '1px solid #222',
    marginTop: '30px',
    paddingTop: '20px',
    textAlign: 'center',
    fontSize: '0.75rem',
    color: '#555',
  }
};

export default Footer;